"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useEventHandler_1 = require("../utils/useEventHandler");
var NsCalendar = function (_a) {
    var onChange = _a.onChange, disabledDates = _a.disabledDates, enabledDates = _a.enabledDates, minDate = _a.minDate, maxDate = _a.maxDate, isoSelectedDate = _a.isoSelectedDate, year = _a.year, month = _a.month;
    var ref = react_1.default.useRef();
    (0, useEventHandler_1.useEventHandler)(ref, 'change', onChange);
    return (react_1.default.createElement("ns-calendar", { ref: ref, "disabled-dates": disabledDates, "enabled-dates": enabledDates, "min-date": minDate, "max-date": maxDate, "iso-selected-date": isoSelectedDate, year: year, month: month }));
};
exports.default = NsCalendar;
